<div mat-dialog-content fxLayoutAlign="center center" fxLayout="column">
    <mat-spinner></mat-spinner>
    <h4>{{message}}</h4>
</div>
